/* eslint camelcase: 0 */
import { TalkTalker } from '@/infrastructure/network/Monitaro/schema/models'
import { ITalkerProps, EmptyTalkerPropsFactory } from '@/entities/Talker'
import RoomTalker from '@/infrastructure/network/Monitaro/schema/models/RoomTalker'

export const toTalkerProps = (props: TalkTalker | null | undefined, type?: string): ITalkerProps => {
  if (!props) {
    return EmptyTalkerPropsFactory()
  }

  const { id, fullname, organization, icon } = props

  return EmptyTalkerPropsFactory({
    id,
    fullname,
    organization,
    icon,
    type
  })
}

export const toRoomTalkerProps = (props: RoomTalker | null | undefined): ITalkerProps => {
  if (!props) {
    return EmptyTalkerPropsFactory()
  }

  const { id, fullname, organization, icon } = EmptyTalkerPropsFactory(props.talker)

  // talker_typeからtypeを自動判定
  const type = props.talker_type?.includes('User') ? 'user' : props.talker_type?.includes('Doctor') ? 'doctor' : undefined

  return EmptyTalkerPropsFactory({
    id,
    fullname,
    organization,
    icon,
    type
  })
}
